module.exports = __webpack_public_path__ + "static/img/22.457e28f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/22.png
// module id = PpPa
// module chunks = 0